import { LucideIcon, TrendingUp, TrendingDown } from 'lucide-react';

interface StatsCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  trend?: {
    value: number;
    label: string;
  };
  tone?: 'primary' | 'success' | 'warning' | 'danger' | 'info';
}

const toneClasses = {
  primary: 'bg-primary/15 text-link',
  success: 'bg-success text-success-foreground',
  warning: 'bg-warning text-warning-foreground',
  danger: 'bg-destructive/10 text-error-text',
  info: 'bg-info text-info-foreground',
};

export function StatsCard({ title, value, icon: Icon, trend, tone = 'primary' }: StatsCardProps) {
  const isPositiveTrend = trend && trend.value >= 0;

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-muted-foreground">{title}</p>
          <p className="mt-1 font-mono text-3xl font-normal text-foreground">{value}</p>
        </div>
        <div className={`p-3 rounded-lg ${toneClasses[tone]}`}>
          <Icon className="w-5 h-5" />
        </div>
      </div>

      {trend && (
        <div className="mt-4 flex items-center gap-1">
          {isPositiveTrend ? (
            <TrendingUp className="w-4 h-4 text-success-foreground" />
          ) : (
            <TrendingDown className="w-4 h-4 text-error-text" />
          )}
          <span className={`text-sm font-medium ${isPositiveTrend ? 'text-success-foreground' : 'text-error-text'}`}>
            {trend.value > 0 ? '+' : ''}{trend.value}%
          </span>
          <span className="text-sm text-muted-foreground">{trend.label}</span>
        </div>
      )}
    </div>
  );
}
